$(function() {
    if($("#score").length > 0){
          $.get('/get_rating_courses', {course_id: $("#score").attr("data-course_id")}, function (data) {
            $('#score').raty({ score: data });
        });
    }
});

 $(document).on('click', '.assesment-course', function () {

        $.get('/rating_courses', {course_id: $(this).parent().attr("data-course_id"), assesment: $(this).attr("alt")});    

});